import Model from 'model/model'

export default Model.extend({
    defaults: {
        isUploaded: true,
    },

    isLoading() {
        return this.has('id')
    },
})
